// TODO: THIS WILL MOVE TO THEME.LIQUID AND CONDITIONAL JS WILL BE SHOWN
// SECONDARY IMAGE FUNC.
document.addEventListener("DOMContentLoaded", function () {
    const allSwatchColors = document.querySelectorAll('.swatch-color');

    const swatchColors = [...allSwatchColors].filter(swatch => {
        return !swatch.closest('.product-form__input');
    });

    swatchColors.forEach(function (swatch) {
        const handleHoverOrTouch = function (e) {
            const wrapper = swatch.closest(".product-card__wrapper");
            const swatchButtons = [...wrapper.querySelectorAll('.swatch-color')].filter(btn => {
                return !btn.closest('.product-form__input');
            });

            swatchButtons.forEach(function (swatchButtonSingle) {
                swatchButtonSingle.classList.remove("active");
            });

            swatch.classList.add("active");

            const color = swatch.dataset.variantColor;
            const variant_href = swatch.dataset.href;
            const variant_alt = swatch.dataset.alt;


            if (color) {
                const hrefContainer = wrapper.querySelectorAll("a");
                const firstImageContainer = wrapper.querySelector(".product-card__image--main");
                const firstImage = firstImageContainer.querySelector("img");
                const secondImageContainer = wrapper.querySelector(".product-card__image--second");
                const secondImage = secondImageContainer.querySelector("img");

                secondImageContainer.classList.add("visible-mobile");
                secondImageContainer.classList.add("loaded");

                if (window.innerWidth < 769) {
                    firstImageContainer.style.display = "none";
                    secondImageContainer.classList.remove("hidden");
                    secondImageContainer.classList.remove("loading");
                    // secondImageContainer.classList.remove("product-card__image--second");
                }

                let width_of_image = secondImage?.width || 400;
                let imageUrl = color;
                const hasQuery = imageUrl.includes("?");
                imageUrl += hasQuery ? `&width=${width_of_image}` : `?width=${width_of_image}`;

                const newImage = document.createElement("img");
                newImage.src = imageUrl;
                newImage.className = "product-selected-color";
                newImage.alt = variant_alt;
                secondImageContainer.innerHTML = '';
                secondImageContainer.appendChild(newImage);
                // document.querySelector(".pdp-video-with-text__container").innerHTML = ''
                // document.querySelector(".pdp-video-with-text__container").appendChild(newImage)

                // if (secondImage) {
                //     secondImage.style.display = "none";
                // }

                hrefContainer.forEach(function (hrefSingle) {
                    hrefSingle.href = variant_href;
                });
            }
        };

        if (window.innerWidth < 769) {
            swatch.addEventListener("touchstart", handleHoverOrTouch, { passive: true });
        } else {
            swatch.addEventListener("click", handleHoverOrTouch);
        }
    });
});